(() => {
  if (window.nsProductTabsReady) return;
  window.nsProductTabsReady = true;
  const activate = (tab) => {
    const root = tab.closest('[data-ns-spec-tabs]');
    if (!root) return;
    root.querySelectorAll('[role="tab"]').forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  };
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-ns-spec-tabs] [role="tab"]');
    if (tab) activate(tab);
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-ns-spec-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;
    if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    event.preventDefault();
    activate(tabs[index]);
    tabs[index].focus();
  });
})();
